/* eslint-disable vue/one-component-per-file */
import { h, createApp } from "vue";
import { mountReplace } from "../../../utilities/mount-replace";

export async function initializeFrontendCauseList(el: string, props: any) {
    const frontendCauseList = (await import("./FrontendCauseList.vue")).default;
    // const Vue = (await import("vue")).default;
    const comp = createApp({
        name: "frontend-cause-list",
        render: function () {
            return h(frontendCauseList, { ...props });
        },
    });
    mountReplace(comp, el);
}

export async function initializeUserDefaultOptionalAuctionCauseList(
    el: string,
    props: any
) {
    const frontendCauseList = (
        await import("./UserDefaultOptionalAuctionCauseList.vue")
    ).default;
    // const Vue = (await import("vue")).default;
    const comp = createApp({
        name: "frontend-cause-list",
        render: function () {
            return h(frontendCauseList, { ...props });
        },
    });
    mountReplace(comp, el);
}
